/* eslint-disable */
export const courseDownIcon = {
  data: `<svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.6666 12.5951L9.74683 7.70525C9.08177 7.04422 8.74917 6.71369 8.3367 6.71373C7.92423 6.71378 7.5917 7.04439 6.92677 7.70559L6.76723 7.86425C6.10166 8.52605 5.76889 8.85699 5.35611 8.85679C4.94334 8.85665 4.61081 8.52552 3.94575 7.86325L1.3333 5.26172M14.6666 12.5951V8.89785M14.6666 12.5951H10.9452" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'course-down' as const,
};
